
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CarouselComponent } from '../../../../modules/carousel/carousel.component';
import { CarouselTile } from '../../../../modules/carousel/carousel.model';


@Component({
  selector: 'app-aktuell-carousel',
  imports: [
    CarouselComponent
  ],
  templateUrl: './aktuell-carousel.component.html',
  styleUrls: ['./aktuell-carousel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AktuellCarouselComponent {
  /**
    * Tiles for the carousel
    */
  public tiles: CarouselTile[] = [
    {
      img: {
        src: 'assets/img/sm/sunset2.jpg',
        // width: 912,
        // height: 618,
        alt: 'Sonnenuntergang im YSTM',
        // srcset: [
        //   'assets/img/xs/sunset2.webp 688w',
        //   'assets/img/sm/sunset2.webp 912w',
        //   'assets/img/md/sunset2.webp 1120w',
        //   'assets/img/lg/sunset2.webp 1360w',
        //   'assets/img/xl/sunset2.webp 2320w',
        // ],
        sizes: ['90vw'],
        priority: true,
      }
    },
    {
      img: {
        src: 'assets/img/sm/idm1.jpg',
        // width: 912,
        // height: 604,
        alt: 'P-Boot Regatta im YSTM',
        // srcset: [
        //   'assets/img/xs/idm1.webp 688w',
        //   'assets/img/sm/idm1.webp 912w',
        //   'assets/img/md/idm1.webp 1120w',
        //   'assets/img/lg/idm1.webp 1360w',
        //   'assets/img/xl/idm1.webp 2320w',
        // ],
        sizes: ['90vw'],
        loading: 'lazy',
      }
    },
    {
      img: {
        src: 'assets/img/sm/restaurant3.jpg',
        // width: 912,
        // height: 606,
        alt: 'Dinner im YSTM',
        // srcset: [
        //   'assets/img/xs/restaurant3.webp 688w',
        //   'assets/img/sm/restaurant3.webp 912w',
        //   'assets/img/md/restaurant3.webp 1120w',
        //   'assets/img/lg/restaurant3.webp 1360w',
        //   'assets/img/xl/restaurant3.webp 2320w',
        // ],
        sizes: ['90vw'],
        loading: 'lazy',
      }
    },
    {
      img: {
        src: 'assets/img/sm/topcat1.jpg',
        // width: 912,
        // height: 608,
        alt: 'Katamaran-Segeln im YSTM',
        // style: 'width:100%;height:100%;object-fit:cover;object-position:50% 80%;',
        objectPosition: '50% 80%',
        // srcset: [
        //   'assets/img/xs/topcat1.webp 688w',
        //   'assets/img/sm/topcat1.webp 912w',
        //   'assets/img/md/topcat1.webp 1120w',
        //   'assets/img/lg/topcat1.webp 1360w',
        //   'assets/img/xl/topcat1.webp 1752w',
        // ],
        sizes: ['90vw'],
        loading: 'lazy',
      }
    },
    {
      img: {
        src: 'assets/img/sm/community1.jpg',
        // width: 912,
        // height: 608,
        alt: 'Ausklang des Tages im YSTM',
        // srcset: [
        //   'assets/img/xs/community1.webp 688w',
        //   'assets/img/sm/community1.webp 912w',
        //   'assets/img/md/community1.webp 1120w',
        //   'assets/img/lg/community1.webp 1360w',
        //   'assets/img/xl/community1.webp 1400w',
        // ],
        sizes: ['90vw'],
        loading: 'lazy',
      }
    },
    {
      img: {
        src: 'assets/img/sm/pboot-h3.jpg',
        // width: 912,
        // height: 604,
        alt: 'P-Boot Training im YSTM',
        // style: 'width:100%;height:100%;object-fit:cover;object-position:50% 80%;',
        objectPosition: '50% 80%',
        // srcset: [
        //   'assets/img/xs/pboot-h3.webp 688w',
        //   'assets/img/sm/pboot-h3.webp 912w',
        //   'assets/img/md/pboot-h3.webp 1120w',
        //   'assets/img/lg/pboot-h3.webp 1360w',
        //   'assets/img/xl/pboot-h3.webp 2320w',
        // ],
        sizes: ['90vw'],
        loading: 'lazy',
      }
    },
  ];
}
